// Chép nguyên sang HP-Media/src/app/features/gala/lib/seat-names.ts — sửa cả hai nơi.
//
// Quyết định in tên người dưới / quanh ghế trên sơ đồ (thuần, dùng ở trang quản trị).
// Tên rút gọn (8 ký tự + "…", cỡ 9) rộng ~40 đơn vị thiết kế.

import { TableLayout, layoutRoom } from './seat-layout';

/** Tên kề nhau cách ít nhất chừng này thì in cùng một khoảng cách. */
export const NAME_MIN_GAP = 38;
/** Dưới mức này so le cũng không đủ chỗ (2 × gap < 40): bỏ tên, chỉ còn <title>/aria-label. */
export const NAME_STAGGER_MIN_GAP = 20;
/** So le: ghế lẻ (chỉ số 0-based lẻ) đẩy tên xa thêm một dòng chữ. */
export const NAME_STAGGER = 12;

export type NameMode = 'normal' | 'stagger' | 'hidden';

export function nameMode(gap: number): NameMode {
  if (gap >= NAME_MIN_GAP) return 'normal';
  if (gap >= NAME_STAGGER_MIN_GAP) return 'stagger';
  return 'hidden';
}

/**
 * Khoảng đẩy thêm cho tên của ghế thứ `index` (0-based trong vòng / trong hàng).
 * `ringCount`: số ghế của một vòng khép kín (bàn tròn) — vòng lẻ thì ghế cuối kề cả ghế đầu (chẵn)
 * lẫn ghế áp chót (lẻ) nên đẩy thêm hai dòng.
 */
export function nameExtraOffset(mode: NameMode, index: number, ringCount?: number): number {
  if (mode !== 'stagger') return 0;
  if (ringCount && ringCount % 2 === 1 && ringCount > 1 && index === ringCount - 1) {
    return 2 * NAME_STAGGER;
  }
  return index % 2 === 1 ? NAME_STAGGER : 0;
}

/**
 * Khoảng cách giữa hai tên kề nhau. Bàn dài: hai ghế đầu hàng trên (bàn 2 ghế: trên/dưới).
 * Bàn tròn: tên nằm trên vòng xa tâm hơn vòng ghế (bán kính ring + seatR + 12) nên giãn theo tỉ lệ.
 */
export function nameGap(t: TableLayout): number {
  if (t.seats.length < 2) return Infinity;
  const [a, b] = t.seats;
  const d = Math.hypot(a.x - b.x, a.y - b.y);
  if (t.shape === 'LONG') return d;
  const ring = Math.hypot(a.x - t.cx, a.y - t.cy);
  return (d * (ring + t.seatR + 12)) / ring;
}

/** Chế độ in tên của một bàn chỉ phụ thuộc hình + số ghế (không phụ thuộc vị trí trên lưới). */
export function tableNameMode(shape: 'ROUND' | 'LONG', capacity: number): NameMode {
  const [t] = layoutRoom([{ id: 0, name: '', shape, capacity, sortOrder: 0 }], {
    columns: 2,
  }).tables;
  return nameMode(nameGap(t));
}
